module.exports = __webpack_public_path__ + "static/locales/en.1VvxdGC.json";